import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { EntityClassificationCreateComponent } from './batch-actions/entity-classification-create/entity-classification-create/entity-classification-create.component';
import { EntityClassificationUpdateComponent } from './batch-actions/entity-classification-create/entity-classification-update/entity-classification-update/entity-classification-update.component';
import { EntityClassificationActionsService } from './batch-actions/entity-classification-create/services/entity-classification-actions.service';
import { Config851DataComponent } from './config851-data/config851-data.component';
import { AppNgMaterialModule } from '../app-ng-material.module';
import { EcConfigurationComponent } from './ec-configuration/ec-configuration.component';
import { EntityFillingComponent } from './entity-filling/entity-filling.component';
import { ScenarioSetupComponent } from './scenario-Setup/scenario-setup.component';
import { EcQuartermapSetupComponent } from './ec-quartermap-setup/ec-quartermap-setup.component';
import { EcRefreshSetupComponent } from './ec-refresh-setup/ec-refresh-setup.component';
import { EcThresholdSetupComponent } from './ec-threshold-setup/ec-threshold-setup.component';
import { EcThresholdDeleteComponent } from './ec-threshold-delete/ec-threshold-delete.component';
import { ReferenceTableComponent } from './reference-table/reference-table.component';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { SyncEntityClassificationComponent } from './sync-entity-classification/sync-entity-classification.component';

@NgModule({ declarations: [
        EntityClassificationCreateComponent,
        EntityClassificationUpdateComponent,
        Config851DataComponent,
        EcConfigurationComponent,
        ScenarioSetupComponent,
        EntityFillingComponent,
        EcQuartermapSetupComponent,
        EcRefreshSetupComponent,
        EcThresholdSetupComponent,
        EcThresholdDeleteComponent,
        ReferenceTableComponent,
        SyncEntityClassificationComponent
    ],
    exports: [
        EntityClassificationCreateComponent,
        EntityClassificationUpdateComponent,
        Config851DataComponent,
        EcConfigurationComponent,
        ScenarioSetupComponent,
        EntityFillingComponent,
        EcQuartermapSetupComponent,
        EcRefreshSetupComponent,
        EcThresholdSetupComponent,
        EcThresholdDeleteComponent,
        ReferenceTableComponent,
        SyncEntityClassificationComponent
    ], imports: [CommonModule,
        ReactiveFormsModule,
        FormsModule,
        AppNgMaterialModule,
        SharedComponentsModule
        // ToggleModule,
        // SelectorModule,
        // TableModule,
        // MatListModule,
        // ListboxModule,
        // ButtonModule
    ],
    providers: [EntityClassificationActionsService]
})
export class EntityClassificationActionsModule {}
